import { Progress } from "antd";
import React, { useCallback, useState } from "react";
import timerIcon from "../../assets/icon/timerIcon.svg";
import TestTimer from "../../components/timer/timer";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";

function TestHeader({ sectionName, question, questions, index }) {
  const { helperC, dispatchHelper } = HelperContext();
  const { answerC, dispatchAnswer } = AnswerContext();
  const [aboutToFinish, setAboutTOFinish] = useState(false);

  const isTestTypeCal = helperC.testType === "CALIBRATION";

  //progress bar calculation
  const percentCal = (quesNo, quesLength) => {
    return (quesNo / quesLength) * 100;
  };

  const handleAbtTOFin = useCallback((value) => {
    setAboutTOFinish(value);
  }, []);

  let pSectionName;
  // check colon in the test name
  if (/[:]/.test(sectionName)) {
    pSectionName = sectionName.split(":");
  } else {
    console.log("datadata not any colon is there");
    pSectionName = sectionName.split("- ");
  }
  const isTextMatch = question && question.test_format === "text_match_scroll";

  const questionLength = isTextMatch
    ? question.que && question.que.length
    : questions && questions.length;

  const indexToShow = isTextMatch
    ? 50 - parseInt(answerC.textMatchAttempt)
    : index + 1;

  return (
    <div className="test-header">
      {questions &&
        !(
          "CONTINUOUS PERFORMANCE" === sectionName ||
          sectionName === "DUAL N-BACK 1"
        ) && (
          <div className="test-number">
            <h4>{indexToShow}</h4>
            <Progress
              percent={percentCal(
                isTextMatch ? answerC.textMatchAttempt : indexToShow,
                questionLength
              )}
              showInfo={false}
            />
          </div>
        )}
      <span className="test-name">
        <span className="calibration-name">
          {isTestTypeCal ? "Calibration Test" : ""}
        </span>
        {isTestTypeCal && <br />}
        <span className="section-name">
          {pSectionName[1] ? pSectionName[1] : sectionName}
        </span>
      </span>
      {questions &&
        !(
          sectionName === "CONTINUOUS PERFORMANCE" ||
          sectionName === "DUAL N-BACK 1"
        ) && (
          <div className="test-time">
            {!(
              sectionName === "SIMPLE REACTION" ||
              sectionName === "CT: SIMPLE REACTION" ||
              sectionName === "CT- SIMPLE REACTION " ||
              sectionName === "M: SIMPLE REACTION" ||
              sectionName === "CHOICE REACTION" ||
              sectionName === "CT- CHOICE REACTION" ||
              sectionName === "CT: CHOICE REACTION" ||
              sectionName === "M: CHOICE REACTION" ||
              sectionName === "CONTINUOUS PERFORMANCE" ||
              sectionName === "DUAL N-BACK 1" ||
              sectionName === "CT: DUAL N-BACK 1" ||
              sectionName === "M: DUAL N-BACK 1"
            ) && (
              <div
                className={`test-time-content ${
                  aboutToFinish && "aboutToFinish"
                }`}
              >
                <img src={timerIcon} alt="" />
                <TestTimer
                  resp_time={question.resp_time}
                  dispatchHelper={dispatchHelper}
                  handleAbtTOFin={handleAbtTOFin}
                ></TestTimer>
              </div>
            )}
          </div>
        )}
    </div>
  );
}

export default React.memo(TestHeader);
